export const VEHICLE_SEARCH_HINT = 'Search vehicle registration ';

export const VEHICLE_DETAIL_HEADING = 'Vehicle Details';

export const VEHICLE_INFO_REGISTRATION = 'Registration number';
export const VEHICLE_INFO_DRIVER = 'Current driver';
export const VEHICLE_INFO_COSTCENTER_HEADING = 'Current cost centre';

export const VEHICLE_COSTCENTER_HISTORY = 'Cost centre history';

export const CHANGE_COSTCENTER_HEADING = 'Change cost centres?';
export const CHANGE_COSTCENTER_HINT =
  'Please note that changes made to vehicle cost centres will directly affect invoicing.';

export const CHANGE_COSTCENTER_SUCCESS_TITLE = 'Cost centre change successful';

export const RECORD_NUMBER = 20;



// WEBPACK FOOTER //
// ./src/features/relocations/vehicle/content.js